import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f532393a")

_pushScopeId("data-v-f532393a")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header card-p border-0" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_8 = { class: "card-body p-0" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_13 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_14 = { class: "menu-item-wrapper" }
const _hoisted_15 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_17 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(`${_ctx.$t('message.SUBSIDIARY')} ${_ctx.$t('message.LIST')} `), 1)
          ]),
          (_ctx.customer?.user?.status != 0)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "link",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addSubsidiary && _ctx.addSubsidiary(...args))),
                class: "btn-custom",
                style: {"width":"40px","height":"40px","overflow":"hidden","border-radius":"50%","display":"flex","flex-wrap":"wrap","justify-content":"center","align-items":"center"}
              }, [
                _hoisted_7
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Search, {
          filter: false,
          showExport: false,
          clearInput: true,
          filterPlaceholder: 'message.SELECT',
          inputPlaceholder: "message.ENTER_KEY_TO_SEARCH_ADDRESS",
          onSearch: _ctx.searchHandler,
          onReloadListing: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSubsidiaries(1)))
        }, null, 8, ["filterPlaceholder", "onSearch"]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Table, {
              loading: _ctx.loader,
              module: "CustomerDetail",
              columns: _ctx.columns,
              rows: _ctx.customers,
              padding: 5,
              pagination: _ctx.pagination,
              onHandleCurrentChange: _ctx.handleCurrentChange
            }, _createSlots({
              "cell-name": _withId(({ row: item }) => [
                _createTextVNode(_toDisplayString(item?.user?.name), 1)
              ]),
              "cell-email": _withId(({ row: item }) => [
                _createTextVNode(_toDisplayString(item?.user?.email), 1)
              ]),
              "cell-status": _withId(({ row: item }) => [
                (item?.user?.status == 1)
                  ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
              ]),
              "cell-created_at": _withId(({ row: item }) => [
                _createTextVNode(_toDisplayString(item?.user?.created_at), 1)
              ]),
              _: 2
            }, [
              (_ctx.customer?.user?.status != 0)
                ? {
                    name: "cell-actions",
                    fn: _withId(({ row: item }) => [
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          (_ctx.$can('edit_customer'))
                            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                _createVNode("a", {
                                  onClick: ($event: any) => (_ctx.handleEdit(item)),
                                  class: "menu-link me-1"
                                }, [
                                  _hoisted_16,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                                ], 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.$can('delete_customer'))
                            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode("a", {
                                  onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                                  class: "menu-link me-1"
                                }, [
                                  _hoisted_18,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                                ], 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  }
                : undefined
            ]), 1032, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange"])
          ])
        ])
      ])
    ])
  ]))
})